import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import AssemblyContext from './context';
import { usePageMeta } from '../page';
import { SafeAssembly } from '../error-boundaries';

export const getComponent = (type, map) => {
  if (map[type]) {
    return map[type];
  }
  return null;
};

const AssemblyBase = ({ map, assembly }) => {
  const { internal, __typename, contentful_id: contentfulId } = assembly;
  const { type: pageType } = usePageMeta();

  if (!(internal && internal.type)) {
    throw new Error(
      `Attempt to render an assembly (${__typename}) without data. A likely cause is that this assembly was added to a Contentful page that does not support rendering it. Make sure the page's query for the page (${pageType}) this error appeared on contains a fragment for this assembly`
    );
  }

  const Component = getComponent(internal.type, map);

  const memoisedValues = useMemo(() => ({ contentfulId }), [contentfulId]);
  if (Component) {
    return (
      <AssemblyContext.Provider value={memoisedValues}>
        <Component contentfulData={assembly} />
      </AssemblyContext.Provider>
    );
  }

  return null;
};

AssemblyBase.propTypes = {
  map: PropTypes.array,
  assembly: PropTypes.shape({
    contentful_id: PropTypes.string,
    internal: PropTypes.shape({
      type: PropTypes.string.isRequired,
    }),
    __typename: PropTypes.string,
  }).isRequired,
};

export default SafeAssembly(AssemblyBase);
